import { render, staticRenderFns } from "./ReservationCheck.vue?vue&type=template&id=2b47f39c&scoped=true"
import script from "./ReservationCheck.vue?vue&type=script&lang=js"
export * from "./ReservationCheck.vue?vue&type=script&lang=js"
import style0 from "./ReservationCheck.vue?vue&type=style&index=0&id=2b47f39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47f39c",
  null
  
)

export default component.exports